// Dependencies
import { useState, useEffect, useRef, useCallback, useContext } from "react";
import { ReactSVG } from "react-svg";
import { Portal } from 'react-portal';

// Types
import { Types, Components } from '../types';

// Utils
import { WP_PLUGIN_BASE_PATH } from '../utils/config'

// Hooks
import { useDebug } from "../hooks";
 
// Components
import { MinicartContext } from "../contexts/Minicart";

const SidebarHeader = ({ className  }: any) => {
    
    useDebug('SidebarHeader'); 

    // Contexts
    const { itemsCount, toggleState, translations } = useContext( MinicartContext );
    
    return (<>
        <div className={`${className}`}>

            <ReactSVG
                tabIndex={0}
                role="button"
                className={`${className}__icon`}
                src={`${WP_PLUGIN_BASE_PATH}/assets/icons/${'ico-cart-default'}.svg`} 
            />

            <strong className={`${className}__label`}>{translations.cartHeader.title}</strong>

            <div className={`${className}__quantity`}>
                <span>{itemsCount}</span>
            </div>

            <ReactSVG
                tabIndex={0}
                role="button"
                className={`${className}__close`}
                src={`${WP_PLUGIN_BASE_PATH}/assets/icons/${'ico-cross'}.svg`}
                onClick={() => toggleState('opened', false)}
            />

        </div> 
    </>)
}

export default SidebarHeader;